export { ButtonFigure, classNameButtonFigure } from './button-figure';
